import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors, actionCreators } from 'dux/user';
import ProfilePage from './ProfilePage';

const propTypes = {
  getMFAStatus: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  MFAEnabled: PropTypes.bool.isRequired,
};

class ProfilePageContainer extends React.Component {
  componentDidMount() {
    const { getMFAStatus, userId } = this.props;
    getMFAStatus(userId);
  }

  render() {
    const { ...props } = this.props;
    return <ProfilePage {...props} />;
  }
}

const mapStateToProps = (state) => ({
  isAdmin: selectors.isAdmin(state),
  isCustomerAdmin: selectors.isCustomerAdmin(state),
  isBillingUser: selectors.isBillingUser(state),
  userId: selectors.getIdentityState(state).id,
  MFAEnabled: selectors.getIdentityState(state).MFAEnabled,
  flags: selectors.getFeatureFlagsState(state, false).flags,
});

const mapDispatchToProps = {
  getMFAStatus: actionCreators.getMFAStatus,
};

ProfilePageContainer.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePageContainer);
